module.exports = __webpack_public_path__ + "static/media/attachment_removal.968934b2.png";